import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import moment from "moment";
import axios from "axios";

import Info from "./common/info";
import SortOptions from "./common/sortOptions";
import OrderList from "./orderHistory/orderList";

const OrderHistory = ({ active, tabs, selectCompany }) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const [current, setCurrent] = useState({ page: 1, pageSize: 8 });
  const [totalElements, setTotalElements] = useState(10);
  const [data, setData] = useState([]);
  const [searched, setSearched] = useState({ status: "all", createdAt: null });

  useEffect(() => {
    if (current) {
      getOrders(current);
    }
  }, [current]);

  useEffect(() => {
    if (!selectCompany) return;

    const page = { page: 1, pageSize: 8 };
    setCurrent(page);
    setSearched({ status: "all", createdAt: null });

    getOrders(page);
  }, [selectCompany]);

  const getEncryptId = async (id) => {
    const url = "/etc/encrypt-6char";
    const body = { id: parseInt(id, 10) };
    const res = await axios.post(url, body);
    return res.data.code;
  };

  const getOrders = async (current) => {
    const query = `
    query SsOrders(
      $cmpnyNo: Int
      $statusList: [SsStatusType!]
      $page: Int
      $pageSize: Int
      $createdAt: String
      
    ) {
      ssOrders(filter: { cmpnyNo: $cmpnyNo, statusList: $statusList, page: $page, pageSize: $pageSize, createdAt: $createdAt }) {
        orders {
          id
          orderFlag
          price
          status
          createdAt
          price
          products {
            productImgSrc
            productName
            quantity
            price
            options {
              optionName
              optionPrice
            }
          }
          cancelReason
        }
        totalCount
      }
    }
  `;

    const variables = {
      cmpnyNo: selectCompany.value,
      statusList: searched.status && searched.status !== "all" ? [searched.status] : null,
      createdAt: searched.createdAt ? moment(searched.createdAt).format("YYYY-MM-DD") : null,
      page: current.page || 1,
      pageSize: current.pageSize || 8,
    };

    try {
      const res = await axios.post("/erp/ss/orders", { query, variables });

      const orders = res?.data?.orders || [];

      const encryptedOrders = await Promise.all(
        orders.map(async (order) => ({
          ...order,
          orderId: await getEncryptId(order.id),
        })),
      );

      setData(encryptedOrders);
      setTotalElements(res?.data?.totalCount);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Info
        active={active}
        tabs={tabs}
        searched={searched}
        setSearched={setSearched}
        getOrders={getOrders}
        current={current}
        setCurrent={setCurrent}
      />
      <OrderList
        data={data}
        type="orderHistory"
        current={current}
        setCurrent={setCurrent}
        totalElements={totalElements}
      />
    </>
  );
};

export default OrderHistory;
